module.exports = __webpack_public_path__ + "img/border_Ellipse_3D_White.9cad4f5e.svg";